module.exports = __webpack_public_path__ + "static/trekking-b427059a802d76cf6a2adeaf7c15f1ef.svg";